import { DisableFeatureFlag } from 'lib/constants/disable-feature-flags';

/** Key used to pass data in querystring or cookie */
export const DISABLE_FEATURE_SYMBOL = 'disableFeature';
/** Prefix for url rewrite */
const DISABLE_FEATURE_PREFIX = `_${DISABLE_FEATURE_SYMBOL}_`;

/** Gets the rewritten path that includes the disableFeature */
export function getDisableFeatureRewrite(
  pathname: string,
  disableFeature: DisableFeatureFlag[]
): string {
  const path = pathname.startsWith('/') ? pathname : '/' + pathname;

  return `/${DISABLE_FEATURE_PREFIX}${disableFeature.join('|')}${path}`;
}

/** Gets the disableFeature from the rewritten path */
export function getDisableFeatureFromRewrite(pathname: string): DisableFeatureFlag[] {
  const path = pathname.endsWith('/') ? pathname : pathname + '/';
  const result = path.match(`${DISABLE_FEATURE_PREFIX}(.*?)\\/`);

  if (result && result[1] !== '') {
    return (result[1]?.split('|') ?? []) as DisableFeatureFlag[];
  }

  return [];
}

/** Gets the path without the disableFeature */
export function normalizeDisableFeatureRewrite(pathname: string): string {
  const result = pathname.match(`${DISABLE_FEATURE_PREFIX}.*?(?:\\/|$)`);

  return result === null ? pathname : pathname.replace(result[0], '');
}
